import React from 'react'

interface props {
    bytes: number;
    total: number;
    className?: string;
}

function AvailableSpaceIndicator({ bytes, total, className = "" }: props) {

    function sizeUnits(bytes: number) {
        let prefix = "B"
        let size = bytes
        if (bytes > 1000) {
            prefix = "KB"
            size = Math.floor(bytes / 100) / 10
        }
        if (bytes > 1000000) {
            prefix = "MB"
            size = Math.floor(bytes / 100000) / 10
        }
        return `${size}${prefix}`
    }

    return (
        <div className={'bg-radioactiveGradient w-full h-4 overflow-hidden rounded-full relative '+ className}>
            <div
                className='bg-errorGradient h-full' style={{ width: `${bytes / total * 100}%` }}
                children={<span className='text-xs align-super pl-2 absolute'>
                    {Math.floor(bytes / total * 1000) / 10}%
                    <span className='opacity-80 italic pl-2'>{sizeUnits(bytes)}</span>
                </span>}
            />
            <span className='absolute text-xs opacity-80 italic pr-2 top-0 right-0'>{sizeUnits(total)}</span>
        </div>
    )
}

export default AvailableSpaceIndicator